import { Button, Checkbox, Form, Input, message, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import * as React from 'react';
import withStyles from 'react-jss';
import useInput from 'src/hooks/form/useInput';
import { useStaticRadio } from 'src/hooks/form/useRadio';
import useApi from 'src/hooks/useApi';
import { StylesProps } from 'src/Library/Types';
import SEFieldLabel from '../../SECommon/SEFieldLabel';

const styles = (theme) => ({
  modalTitleText: {
    fontSize: 18,
    color: '#424242',
    fontWeight: 600,
  },
  fieldLabel: {
    fontSize: 14,
    color: '#333333',
    fontWeight: 600,
  }
});

interface SETaskRejectionModalProps
  extends StylesProps<ReturnType<typeof styles>>,
    FormComponentProps<any> {
  onCancel: () => void;
  visible: boolean;
}

const SETaskRejectionModal: React.FC<SETaskRejectionModalProps> = ({
  form,
  classes,
  onCancel,
  visible = true,
}) => {
  const reason = useStaticRadio<typeof optionsWithDisabled, any>({
    form,
    disabled: false,
    visible: true,
    key: 'reason',
    label: 'Select the reason of rejection',
  });
  const remark = useInput({
    form,
    disabled: false,
    visible: true,
    key: 'remark',
    label: 'Remark',
    placeholder: 'Type here...',
  });
  const submitApi = useApi((params) => {
    return Promise.resolve({
      data: {
        successMessage: 'Task rejected successfully!',
      },
      isSuccess: true,
    });
  });

  React.useEffect(() => {
    reason.setOptionsData(
      optionsWithDisabled,
      (data) =>
        data?.map((el) => {
          return {
            // label: el.label,
            key: el.value,
            ...el,
          };
        }) || []
    );
  }, []);

  React.useEffect(() => {
    if (submitApi.status === 'FAILED') {
      message.error(submitApi.errorMessage);
    }
    if (submitApi.status === 'FINISHED') {
      message.success(submitApi.data?.successMessage);
      onCancel();
    }
  }, [submitApi.status]);

  const optionsWithDisabled = [
    { label: 'Apple', value: 'Apple' },
    { label: 'Pear', value: 'Pear' },
    { label: 'Orange', value: 'Orange', disabled: false },
  ];

  const handleSubmit = () => {
    form.validateFields(async (err, values) => {
      submitApi.call(values);
    });
  };

  const renderModalContent = () => {
    return (
      <div>
        <SEFieldLabel {...reason} style={styles(null).fieldLabel}/>
        {reason.decorator(
          <Checkbox.Group
            style={{
              display: 'flex',
              flexDirection: 'column',
              // marginTop: 5,
              marginLeft: 10,
              gap: 10,
            }}
          />
        )}
        <SEFieldLabel {...remark} style={styles(null).fieldLabel}/>
        {remark.decorator(<TextArea style={{ marginTop: 5 }}/>)}
      </div>
    );
  };

  const renderModalTitle = () => {
    return (
      <div>
        <span className={classes.modalTitleText}>Remark for Rejection</span>
      </div>
    );
  };

  const renderFooter = () => {
    return [
      <Button key="back" onClick={() => onCancel()}>
        Don't Reject
      </Button>,
      <Button
        key="confirm"
        type="primary"
        loading={submitApi.status === 'RUNNING'}
        onClick={() => handleSubmit()}
      >
        Submit
      </Button>,
    ];
  };

  return (
    <Modal
      width="30%"
      visible={visible}
      onCancel={onCancel}
      title={renderModalTitle()}
      footer={renderFooter()}
    >
      {renderModalContent()}
    </Modal>
  );
};

export default withStyles(styles)(React.memo(Form.create({})(SETaskRejectionModal)));
